<div infiniteScroll [infiniteScrollDistance]="2" (scrolled)="onScroll()">
  <div class="wrapper-content ">
    <div class="wrapper-header">
      <h1 class="text-center">El proyecto en imágenes</h1>
    </div>
  </div>

  <div class="wrapper-content-fitted " style="margin-bottom: 50px;" *ngIf="route.publicRoutes">
    <div class="filter-panel">
      <div ngbDropdown class="d-inline-block app-dropdown-menu float-left">
        <button class="btn btn-dark" id="dropdownBasic1" ngbDropdownToggle>
          <span style="color:white" *ngFor="let item of webcontext"
            [hidden]="item.name != context">{{item.title.es}}</span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
          <button ngbDropdownItem (click)="pickContext(item);"
            *ngFor="let item of webcontext">{{item.title.es}}</button>
        </div>
      </div>
    </div>
  </div>

  <div class="wrapper-content-fitted" *ngIf="blog">
    <div class="wwf-box" *ngFor="let card of blog">
      <div class="wwf-card" magic [magicCss]="{type:'square'}" [style.background]="'url('+api.getImageUrl(card.image)+')'">
        <a class="wwf-card--mask" (click)="route.goTo('articulo/'+card.name)"  [style.background]="'url('+api.getImageUrl(card.image)+')'" target="_blank"></a>
        <div class="wwf-card--body">
          <h4 class="wwf-card--title">{{card.title.es}}</h4>
          <p class="wwf-card--tag ts-color-2">{{card.created_at}}</p>
        </div>
        <div class="wwf-card--btn ts-background-5">
          <svg xmlns="http://www.w3.org/2000/svg" width="40.001" height="40" viewBox="0 0 40.001 40">
            <path id="ver-mas" d="M17.5-7850v-17.5H0v-5H17.5V-7890h5v17.5H40v5H22.5v17.5Z" transform="translate(0 7890)"
              fill="#fff" />
          </svg>
        </div>
      </div>
    </div>
  </div>

</div>
<app-footer></app-footer>
